import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AccountData} from '../../../shared/components/identite-personne/data/account.data';

@Component({
    selector: 'jhi-inscription-reussie',
    templateUrl: 'inscription-reussie.component.html',
    styleUrls: ['inscription-reussie.component.scss']
})

export class InscriptionReussieComponent implements OnInit {

    email: string;

    constructor(private router: Router,
                private accountData: AccountData) {
    }

    ngOnInit() {
        this.email = this.accountData.email;
        this.accountData = new AccountData();
    }

    goToAcceuil() {
        this.router.navigate(['/']);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/inscription-reussie/inscription-reussie.component.ts